var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { AnswerHomeworkContainer, AttachImage, CloseImage, CommentImage, CommentImageList, LoaderWrapper, CommentInput, InputCommentContainer, InputContainer, SubmitButton, CheckHomeworkPictureIconWrapper } from '../style';
import { FlexBox, useBreakpoint, useToasts } from "@brg/ui";
import BigImageComp from "../../../editor/bigimage";
import { useUppyLoader } from "../components/UppyLoader";
import { LOADER_TEXT } from "../courseHomeWork";
import { HomeworkCommentList } from "./HomeworkCommentList";
import { API, Endpoints } from "@brg/api";
import { useAuth, useProfile } from "@brg/auth";
import { uploadValidator } from "../../../editor/updateel";
import useCommonProps from "../../../../../../hooks/useCommonProps";
import useLocalization from "../../../../../../hooks/useLocalization";
import { LoaderIcon, LoaderText } from "../../../../../modals/LoaderModal";
var ImageCommentContainer = function (_a) {
    var data = _a.data, onRemoveImage = _a.onRemoveImage, onAddImage = _a.onAddImage, fileRef = _a.fileRef, isLoading = _a.isLoading;
    var is1440 = useBreakpoint(1440);
    var smHeight = useMemo(function () { return (window.innerHeight < 920); }, []);
    var t = useLocalization().t;
    if (!data || !(data === null || data === void 0 ? void 0 : data.length))
        return false;
    return React.createElement(FlexBox, { width: '100%', style: { marginTop: ((is1440 || smHeight) ? 16 : 24) + 'px' } }, isLoading
        ? React.createElement(LoaderWrapper, null,
            React.createElement(LoaderIcon, null),
            React.createElement(LoaderText, null, t('modal.loader.isLoading'))) : React.createElement(CommentImageList, null, data === null || data === void 0 ? void 0 : data.map(function (item, index) { return (item === null || item === void 0 ? void 0 : item.src) && React.createElement(FlexBox, { gx: 8 },
        React.createElement(CommentImage, { src: item === null || item === void 0 ? void 0 : item.src, alt: 'big', key: index }),
        React.createElement(CloseImage, { onClick: function () { return onRemoveImage(item === null || item === void 0 ? void 0 : item.name); } })); })));
};
export var HomeworkComment = function (_a) {
    var isAnswerCommentBlockHidden = _a.isAnswerCommentBlockHidden, postId = _a.postId, isCommentLock = _a.isCommentLock;
    var fileRef = useRef();
    var _b = useState([]), files = _b[0], setFiles = _b[1];
    var auth = useAuth();
    var _c = useState(Date.now()), time = _c[0], setTime = _c[1];
    var _d = useState(true), withImage = _d[0], setWithImage = _d[1];
    var _e = useState(''), currentText = _e[0], setCurrentText = _e[1];
    var profile = useProfile();
    var is1440 = useBreakpoint(1440);
    var is992 = useBreakpoint(992);
    var is744 = useBreakpoint(744);
    var smHeight = useMemo(function () { return (window.innerHeight < 920); }, []);
    var toasts = useToasts();
    var _f = useCommonProps(), projectId = _f.projectId, longreadId = _f.longreadId;
    var t = useLocalization().t;
    var onUploadComplete = useCallback(function (uploadComplete) {
        if (uploadComplete) {
            setFiles([]);
        }
    }, []);
    var onAddImage = useCallback(function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var newFiles, multipleFilesCheckResult, allowed, _a;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    newFiles = ((_b = Array.from(e.target.files)) === null || _b === void 0 ? void 0 : _b.length) > 10 ? (_c = Array.from(e.target.files)) === null || _c === void 0 ? void 0 : _c.slice(0, 10) : Array.from(e.target.files);
                    if (fileRef === null || fileRef === void 0 ? void 0 : fileRef.current)
                        fileRef.current.value = '';
                    multipleFilesCheckResult = [];
                    if (!((newFiles === null || newFiles === void 0 ? void 0 : newFiles.length) > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, Promise.all(newFiles.map(function (img) { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, uploadValidator({
                                            files: [img],
                                            toasts: toasts,
                                            isWideImageType: false,
                                            profile: profile,
                                            isComment: true
                                        })];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            });
                        }); }))];
                case 1:
                    multipleFilesCheckResult = _d.sent();
                    _d.label = 2;
                case 2:
                    if (!((files === null || files === void 0 ? void 0 : files.length) > 0)) return [3 /*break*/, 4];
                    return [4 /*yield*/, uploadValidator({
                            files: files,
                            toasts: toasts,
                            isWideImageType: false,
                            profile: profile,
                            isComment: true
                        })];
                case 3:
                    _a = _d.sent();
                    return [3 /*break*/, 5];
                case 4:
                    _a = true;
                    _d.label = 5;
                case 5:
                    allowed = _a;
                    if (!allowed || (multipleFilesCheckResult === null || multipleFilesCheckResult === void 0 ? void 0 : multipleFilesCheckResult.includes(false))) {
                        e.target.value = '';
                        return [2 /*return*/];
                    }
                    setTime(Date.now());
                    setTimeout(function () {
                        setFiles(function (prev) { return __spreadArray(__spreadArray([], (prev || []), true), newFiles, true); });
                    }, 0);
                    return [2 /*return*/];
            }
        });
    }); }, [files, fileRef]);
    var onRemoveImage = useCallback(function (id) {
        if (fileRef === null || fileRef === void 0 ? void 0 : fileRef.current)
            fileRef.current.value = '';
        setFiles(files === null || files === void 0 ? void 0 : files.filter((function (file) { return (file === null || file === void 0 ? void 0 : file.name) !== id; })));
        setTime(Date.now());
    }, [files, fileRef]);
    var _g = useUppyLoader(files, fileRef, onUploadComplete, time), uppy = _g[0], data = _g[1], isLoading = _g[2];
    var _h = useState(Date.now()), commentT = _h[0], setCommentT = _h[1];
    var _j = useState('center'), iconPosition = _j[0], setIconPosition = _j[1];
    var textAreaRef = useRef(null);
    var adjustHeight = function (element) {
        var initialHeight = 46;
        element.style.height = "".concat(initialHeight, "px");
        var newHeight = Math.max(initialHeight, Math.min(element.scrollHeight, 220));
        element.style.height = "".concat(newHeight, "px");
        element.style.overflowY = newHeight >= 220 ? "auto" : "hidden";
        if (newHeight > 46) {
            setIconPosition('flex-end');
        }
        else {
            setIconPosition('center');
        }
    };
    useEffect(function () {
        if (textAreaRef.current) {
            adjustHeight(textAreaRef.current);
        }
    }, [currentText]);
    var onSave = useCallback(function () {
        if (isAnswerCommentBlockHidden) {
            auth.login();
            return;
        }
        if (fileRef === null || fileRef === void 0 ? void 0 : fileRef.current)
            fileRef.current.value = '';
        setCurrentText("");
        setFiles([]);
        setTime(Date.now());
        API.request()
            .endpoint(Endpoints.gateway)
            .url("message/api/comment/Add")
            .post()
            .body(__assign({ entityId: postId, entityType: "post", accountId: profile === null || profile === void 0 ? void 0 : profile.accountId, text: currentText, type: 2, additionalInfo: {
                moduleProjectId: projectId,
                themeLongreadId: longreadId
            } }, (((data === null || data === void 0 ? void 0 : data.length) > 0) ? { attachments: data === null || data === void 0 ? void 0 : data.map(function (file) { return ({ files: [{ fileId: file === null || file === void 0 ? void 0 : file.id }] }); }) } : {})))
            .release()
            .then(function (r) { return r.json; })
            .then(function (r) {
            setTimeout(function () { return setCommentT(Date.now()); }, 1000);
        });
    }, [currentText, postId, profile, data, longreadId, projectId, isAnswerCommentBlockHidden, fileRef]);
    if (is744)
        return React.createElement(FlexBox, { direction: "column", directionMobile: "column", gy: 16 },
            React.createElement(HomeworkCommentList, { isCommentLock: isCommentLock, postId: postId, t: commentT, setT: setCommentT }),
            !isCommentLock && React.createElement(AnswerHomeworkContainer, null,
                React.createElement(FlexBox, { width: '100%', justify: 'space-between', align: 'flex-end' },
                    React.createElement(FlexBox, { width: '100%', direction: "column", directionMobile: "column", gy: 16 },
                        React.createElement(FlexBox, { width: '100%', justify: 'space-between' },
                            React.createElement("div", null, t('lms.comment.add_comment')),
                            React.createElement(CheckHomeworkPictureIconWrapper, null,
                                React.createElement(AttachImage, null),
                                React.createElement("input", { type: "file", accept: "image/jpeg, image/gif, image/png", multiple: true, ref: fileRef, onChange: function (e) {
                                        onAddImage(e);
                                    } }))),
                        React.createElement(FlexBox, { width: '100%', gx: 16, justify: 'space-between', align: 'flex-end' },
                            React.createElement(CommentInput, { value: currentText, className: 'mobile-textarea', onChange: function (e) { return setCurrentText(e.target.value); }, maxLength: 2400 }),
                            React.createElement("div", { style: { fontSize: 12, color: '#909090', marginLeft: 8 } },
                                currentText.length,
                                "/2400")),
                        React.createElement(ImageCommentContainer, { isLoading: isLoading, data: data, onRemoveImage: onRemoveImage, onAddImage: onAddImage, fileRef: fileRef }),
                        React.createElement(SubmitButton, { onClick: onSave, disabled: (currentText === null || currentText === void 0 ? void 0 : currentText.length) === 0 && (files === null || files === void 0 ? void 0 : files.length) === 0 }, t('lms.comment.send'))))));
    if (is992)
        return React.createElement(FlexBox, { direction: "column", directionMobile: "column", gy: 16 },
            React.createElement(HomeworkCommentList, { isCommentLock: isCommentLock, postId: postId, t: commentT, setT: setCommentT }),
            !isCommentLock && React.createElement(AnswerHomeworkContainer, null,
                React.createElement(FlexBox, { width: '100%', justify: 'space-between', align: 'flex-end' },
                    React.createElement(FlexBox, { width: '100%', direction: "column", directionMobile: "column", gy: 16 },
                        React.createElement(FlexBox, { width: '100%', justify: 'space-between' },
                            React.createElement("div", null, t('lms.comment.add_comment')),
                            React.createElement(CheckHomeworkPictureIconWrapper, null,
                                React.createElement(AttachImage, null),
                                React.createElement("input", { type: "file", accept: "image/jpeg, image/gif, image/png", multiple: true, ref: fileRef, onChange: function (e) {
                                        onAddImage(e);
                                    } }))),
                        React.createElement(FlexBox, { width: '100%', gx: 16, justify: 'space-between', align: 'flex-end' },
                            React.createElement(CommentInput, { ref: textAreaRef, className: 'mobile-textarea', value: currentText, onChange: function (e) { return setCurrentText(e.target.value); }, maxLength: 2400 }),
                            React.createElement("div", { style: { fontSize: 12, color: '#909090', marginLeft: 8 } },
                                currentText.length,
                                "/2400"),
                            React.createElement(SubmitButton, { onClick: onSave, disabled: (currentText === null || currentText === void 0 ? void 0 : currentText.length) === 0 && (files === null || files === void 0 ? void 0 : files.length) === 0 }, t('lms.comment.send'))),
                        React.createElement(ImageCommentContainer, { isLoading: isLoading, data: data, onRemoveImage: onRemoveImage, onAddImage: onAddImage, fileRef: fileRef })))));
    return React.createElement(FlexBox, { direction: "column", directionMobile: "column", gy: 24 },
        React.createElement(HomeworkCommentList, { isCommentLock: isCommentLock, postId: postId, t: commentT, setT: setCommentT }),
        !isCommentLock && React.createElement(AnswerHomeworkContainer, null,
            React.createElement(FlexBox, { width: '100%', justify: 'space-between', align: 'flex-end' },
                React.createElement(FlexBox, { direction: "column", directionMobile: "column", gy: 16 },
                    React.createElement("div", null, t('lms.comment.add_comment')),
                    React.createElement(FlexBox, { gx: 24, align: iconPosition },
                        React.createElement(CommentInput, { ref: textAreaRef, className: 'mobile-textarea', placeholder: t('lms.comment.type_something'), value: currentText, onChange: function (e) { return setCurrentText(e.target.value); }, maxLength: 2400 }),
                        React.createElement("div", { style: { fontSize: 12, color: '#909090', marginLeft: 8 } },
                            currentText.length,
                            "/2400"),
                        React.createElement(CheckHomeworkPictureIconWrapper, null,
                            React.createElement(AttachImage, null),
                            React.createElement("input", { type: "file", accept: "image/jpeg, image/gif, image/png", multiple: true, ref: fileRef, onChange: function (e) {
                                    onAddImage(e);
                                } }))),
                    React.createElement(ImageCommentContainer, { isLoading: isLoading, data: data, onRemoveImage: onRemoveImage, onAddImage: onAddImage, fileRef: fileRef })),
                React.createElement(SubmitButton, { onClick: onSave, disabled: (currentText === null || currentText === void 0 ? void 0 : currentText.length) === 0 && (files === null || files === void 0 ? void 0 : files.length) === 0 }, t('lms.comment.send')))));
};
//# sourceMappingURL=HomeworkComment.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { AnswerHomeworkContainer, AttachImage, CloseImage, CommentImage, CommentImageList, LoaderWrapper, CommentInput, InputCommentContainer, InputContainer, SubmitButton, CheckHomeworkPictureIconWrapper } from '../style';
import { FlexBox, useBreakpoint, useToasts } from "@brg/ui";
import BigImageComp from "../../../editor/bigimage";
import { useUppyLoader } from "../components/UppyLoader";
import { LOADER_TEXT } from "../courseHomeWork";
import { HomeworkCommentList } from "./HomeworkCommentList";
import { API, Endpoints } from "@brg/api";
import { useAuth, useProfile } from "@brg/auth";
import { uploadValidator } from "../../../editor/updateel";
import useCommonProps from "../../../../../../hooks/useCommonProps";
import useLocalization from "../../../../../../hooks/useLocalization";
import { LoaderIcon, LoaderText } from "../../../../../modals/LoaderModal";
var ImageCommentContainer = function (_a) {
    var data = _a.data, onRemoveImage = _a.onRemoveImage, onAddImage = _a.onAddImage, fileRef = _a.fileRef, isLoading = _a.isLoading;
    var is1440 = useBreakpoint(1440);
    var smHeight = useMemo(function () { return (window.innerHeight < 920); }, []);
    var t = useLocalization().t;
    if (!data || !(data === null || data === void 0 ? void 0 : data.length))
        return false;
    return React.createElement(FlexBox, { width: '100%', style: { marginTop: ((is1440 || smHeight) ? 16 : 24) + 'px' } }, isLoading
        ? React.createElement(LoaderWrapper, null,
            React.createElement(LoaderIcon, null),
            React.createElement(LoaderText, null, t('modal.loader.isLoading'))) : React.createElement(CommentImageList, null, data === null || data === void 0 ? void 0 : data.map(function (item, index) { return (item === null || item === void 0 ? void 0 : item.src) && React.createElement(FlexBox, { gx: 8 },
        React.createElement(CommentImage, { src: item === null || item === void 0 ? void 0 : item.src, alt: 'big', key: index }),
        React.createElement(CloseImage, { onClick: function () { return onRemoveImage(item === null || item === void 0 ? void 0 : item.name); } })); })));
};
export var HomeworkComment = function (_a) {
    var isAnswerCommentBlockHidden = _a.isAnswerCommentBlockHidden, postId = _a.postId, isCommentLock = _a.isCommentLock;
    var fileRef = useRef();
    var _b = useState([]), files = _b[0], setFiles = _b[1];
    var auth = useAuth();
    var _c = useState(Date.now()), time = _c[0], setTime = _c[1];
    var _d = useState(true), withImage = _d[0], setWithImage = _d[1];
    var _e = useState(''), currentText = _e[0], setCurrentText = _e[1];
    var profile = useProfile();
    var is1440 = useBreakpoint(1440);
    var is992 = useBreakpoint(992);
    var is744 = useBreakpoint(744);
    var smHeight = useMemo(function () { return (window.innerHeight < 920); }, []);
    var toasts = useToasts();
    var _f = useCommonProps(), projectId = _f.projectId, longreadId = _f.longreadId;
    var t = useLocalization().t;
    var onUploadComplete = useCallback(function (uploadComplete) {
        if (uploadComplete) {
            setFiles([]);
        }
    }, []);
    var onAddImage = useCallback(function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var newFiles, multipleFilesCheckResult, allowed, _a;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    newFiles = ((_b = Array.from(e.target.files)) === null || _b === void 0 ? void 0 : _b.length) > 10 ? (_c = Array.from(e.target.files)) === null || _c === void 0 ? void 0 : _c.slice(0, 10) : Array.from(e.target.files);
                    if (fileRef === null || fileRef === void 0 ? void 0 : fileRef.current)
                        fileRef.current.value = '';
                    multipleFilesCheckResult = [];
                    if (!((newFiles === null || newFiles === void 0 ? void 0 : newFiles.length) > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, Promise.all(newFiles.map(function (img) { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, uploadValidator({
                                            files: [img],
                                            toasts: toasts,
                                            isWideImageType: false,
                                            profile: profile,
                                            isComment: true
                                        })];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            });
                        }); }))];
                case 1:
                    multipleFilesCheckResult = _d.sent();
                    _d.label = 2;
                case 2:
                    if (!((files === null || files === void 0 ? void 0 : files.length) > 0)) return [3 /*break*/, 4];
                    return [4 /*yield*/, uploadValidator({
                            files: files,
                            toasts: toasts,
                            isWideImageType: false,
                            profile: profile,
                            isComment: true
                        })];
                case 3:
                    _a = _d.sent();
                    return [3 /*break*/, 5];
                case 4:
                    _a = true;
                    _d.label = 5;
                case 5:
                    allowed = _a;
                    if (!allowed || (multipleFilesCheckResult === null || multipleFilesCheckResult === void 0 ? void 0 : multipleFilesCheckResult.includes(false))) {
                        e.target.value = '';
                        return [2 /*return*/];
                    }
                    setTime(Date.now());
                    setTimeout(function () {
                        setFiles(function (prev) { return __spreadArray(__spreadArray([], (prev || []), true), newFiles, true); });
                    }, 0);
                    return [2 /*return*/];
            }
        });
    }); }, [files, fileRef]);
    var onRemoveImage = useCallback(function (id) {
        if (fileRef === null || fileRef === void 0 ? void 0 : fileRef.current)
            fileRef.current.value = '';
        setFiles(files === null || files === void 0 ? void 0 : files.filter((function (file) { return (file === null || file === void 0 ? void 0 : file.name) !== id; })));
        setTime(Date.now());
    }, [files, fileRef]);
    var _g = useUppyLoader(files, fileRef, onUploadComplete, time), uppy = _g[0], data = _g[1], isLoading = _g[2];
    var _h = useState(Date.now()), commentT = _h[0], setCommentT = _h[1];
    var _j = useState('center'), iconPosition = _j[0], setIconPosition = _j[1];
    var textAreaRef = useRef(null);
    var adjustHeight = function (element) {
        var initialHeight = 46;
        element.style.height = "".concat(initialHeight, "px");
        var newHeight = Math.max(initialHeight, Math.min(element.scrollHeight, 220));
        element.style.height = "".concat(newHeight, "px");
        element.style.overflowY = newHeight >= 220 ? "auto" : "hidden";
        if (newHeight > 46) {
            setIconPosition('flex-end');
        }
        else {
            setIconPosition('center');
        }
    };
    useEffect(function () {
        if (textAreaRef.current) {
            adjustHeight(textAreaRef.current);
        }
    }, [currentText]);
    var onSave = useCallback(function () {
        if (isAnswerCommentBlockHidden) {
            auth.login();
            return;
        }
        if (fileRef === null || fileRef === void 0 ? void 0 : fileRef.current)
            fileRef.current.value = '';
        setCurrentText("");
        setFiles([]);
        setTime(Date.now());
        API.request()
            .endpoint(Endpoints.gateway)
            .url("message/api/comment/Add")
            .post()
            .body(__assign({ entityId: postId, entityType: "post", accountId: profile === null || profile === void 0 ? void 0 : profile.accountId, text: currentText, type: 2, additionalInfo: {
                moduleProjectId: projectId,
                themeLongreadId: longreadId
            } }, (((data === null || data === void 0 ? void 0 : data.length) > 0) ? { attachments: data === null || data === void 0 ? void 0 : data.map(function (file) { return ({ files: [{ fileId: file === null || file === void 0 ? void 0 : file.id }] }); }) } : {})))
            .release()
            .then(function (r) { return r.json; })
            .then(function (r) {
            setTimeout(function () { return setCommentT(Date.now()); }, 1000);
        });
    }, [currentText, postId, profile, data, longreadId, projectId, isAnswerCommentBlockHidden, fileRef]);
    if (is744)
        return React.createElement(FlexBox, { direction: "column", directionMobile: "column", gy: 16 },
            React.createElement(HomeworkCommentList, { isCommentLock: isCommentLock, postId: postId, t: commentT, setT: setCommentT }),
            !isCommentLock && React.createElement(AnswerHomeworkContainer, null,
                React.createElement(FlexBox, { width: '100%', justify: 'space-between', align: 'flex-end' },
                    React.createElement(FlexBox, { width: '100%', direction: "column", directionMobile: "column", gy: 16 },
                        React.createElement(FlexBox, { width: '100%', justify: 'space-between' },
                            React.createElement("div", null, t('lms.comment.add_comment')),
                            React.createElement(CheckHomeworkPictureIconWrapper, null,
                                React.createElement(AttachImage, null),
                                React.createElement("input", { type: "file", accept: "image/jpeg, image/gif, image/png", multiple: true, ref: fileRef, onChange: function (e) {
                                        onAddImage(e);
                                    } }))),
                        React.createElement(FlexBox, { width: '100%', gx: 16, justify: 'space-between', align: 'flex-end' },
                            React.createElement(CommentInput, { value: currentText, className: 'mobile-textarea', onChange: function (e) { return setCurrentText(e.target.value); }, maxLength: 2400 }),
                            React.createElement("div", { style: { fontSize: 12, color: '#909090', marginLeft: 8 } },
                                currentText.length,
                                "/2400")),
                        React.createElement(ImageCommentContainer, { isLoading: isLoading, data: data, onRemoveImage: onRemoveImage, onAddImage: onAddImage, fileRef: fileRef }),
                        React.createElement(SubmitButton, { onClick: onSave, disabled: (currentText === null || currentText === void 0 ? void 0 : currentText.length) === 0 && (files === null || files === void 0 ? void 0 : files.length) === 0 }, t('lms.comment.send'))))));
    if (is992)
        return React.createElement(FlexBox, { direction: "column", directionMobile: "column", gy: 16 },
            React.createElement(HomeworkCommentList, { isCommentLock: isCommentLock, postId: postId, t: commentT, setT: setCommentT }),
            !isCommentLock && React.createElement(AnswerHomeworkContainer, null,
                React.createElement(FlexBox, { width: '100%', justify: 'space-between', align: 'flex-end' },
                    React.createElement(FlexBox, { width: '100%', direction: "column", directionMobile: "column", gy: 16 },
                        React.createElement(FlexBox, { width: '100%', justify: 'space-between' },
                            React.createElement("div", null, t('lms.comment.add_comment')),
                            React.createElement(CheckHomeworkPictureIconWrapper, null,
                                React.createElement(AttachImage, null),
                                React.createElement("input", { type: "file", accept: "image/jpeg, image/gif, image/png", multiple: true, ref: fileRef, onChange: function (e) {
                                        onAddImage(e);
                                    } }))),
                        React.createElement(FlexBox, { width: '100%', gx: 16, justify: 'space-between', align: 'flex-end' },
                            React.createElement(CommentInput, { ref: textAreaRef, className: 'mobile-textarea', value: currentText, onChange: function (e) { return setCurrentText(e.target.value); }, maxLength: 2400 }),
                            React.createElement("div", { style: { fontSize: 12, color: '#909090', marginLeft: 8 } },
                                currentText.length,
                                "/2400"),
                            React.createElement(SubmitButton, { onClick: onSave, disabled: (currentText === null || currentText === void 0 ? void 0 : currentText.length) === 0 && (files === null || files === void 0 ? void 0 : files.length) === 0 }, t('lms.comment.send'))),
                        React.createElement(ImageCommentContainer, { isLoading: isLoading, data: data, onRemoveImage: onRemoveImage, onAddImage: onAddImage, fileRef: fileRef })))));
    return React.createElement(FlexBox, { direction: "column", directionMobile: "column", gy: 24 },
        React.createElement(HomeworkCommentList, { isCommentLock: isCommentLock, postId: postId, t: commentT, setT: setCommentT }),
        !isCommentLock && React.createElement(AnswerHomeworkContainer, null,
            React.createElement(FlexBox, { width: '100%', justify: 'space-between', align: 'flex-end' },
                React.createElement(FlexBox, { direction: "column", directionMobile: "column", gy: 16 },
                    React.createElement("div", null, t('lms.comment.add_comment')),
                    React.createElement(FlexBox, { gx: 24, align: iconPosition },
                        React.createElement(CommentInput, { ref: textAreaRef, className: 'mobile-textarea', placeholder: t('lms.comment.type_something'), value: currentText, onChange: function (e) { return setCurrentText(e.target.value); }, maxLength: 2400 }),
                        React.createElement("div", { style: { fontSize: 12, color: '#909090', marginLeft: 8 } },
                            currentText.length,
                            "/2400"),
                        React.createElement(CheckHomeworkPictureIconWrapper, null,
                            React.createElement(AttachImage, null),
                            React.createElement("input", { type: "file", accept: "image/jpeg, image/gif, image/png", multiple: true, ref: fileRef, onChange: function (e) {
                                    onAddImage(e);
                                } }))),
                    React.createElement(ImageCommentContainer, { isLoading: isLoading, data: data, onRemoveImage: onRemoveImage, onAddImage: onAddImage, fileRef: fileRef })),
                React.createElement(SubmitButton, { onClick: onSave, disabled: (currentText === null || currentText === void 0 ? void 0 : currentText.length) === 0 && (files === null || files === void 0 ? void 0 : files.length) === 0 }, t('lms.comment.send')))));
};
//# sourceMappingURL=HomeworkComment.js.map